'use strict';
(function() {

  var RelatedsCarrouselComponent = {
    controller: RelatedsCarrouselComponentCtrl,
    templateUrl: 'relateds-carrousel.component.html',
    bindings: {
      config: '<',
      baseProduct: '<',
      excluded: '<',
      amount: '<',
      onProductClicked: '&',
      onRelatedCarrouselVisible: '&'
    }
  };

  angular.module('itxApp.common')
    .component('relatedsCarrousel', RelatedsCarrouselComponent);

    RelatedsCarrouselComponentCtrl.$inject = [
      'ProductRelatedSvc',
      'Product'
    ];

    function RelatedsCarrouselComponentCtrl(
      ProductRelatedSvc,
      Product
    )
    {
      var _this = this;

      _this.showOnlySiluetas = true;

      _this.$onInit = function() {

        if(_this.baseProduct && !_this.baseProduct.activeDetail){
          _this.baseProduct = new Product(_this.baseProduct);
        }
        _this.firstPhaseAmount = _this.amount + 1;
        ProductRelatedSvc.getRelatedProducts(_this.config.items, _this.baseProduct, _this.excluded, _this.firstPhaseAmount)
        .then(firstPhaseProducts => {
          _this.products = firstPhaseProducts;
          if(_this.products.length >= (_this.amount-1)){
            _this.productsReady = true;
            _this.onRelatedCarrouselVisible();
          }
          _this.config.items = filterEmptyItemConfigs(_this.config.items);
          const remainingCount = remainingProductsCount(_this.config);
          if(remainingCount > 0){
            _this.excluded = _this.excluded.concat(firstPhaseProducts);
            ProductRelatedSvc.getRelatedProducts(_this.config.items, _this.baseProduct, _this.excluded, -1) //al ponerle -1 indicamos que queremos todos los que falten
            .then(secondPhaseProducts => {
              _this.products = _this.products.concat(secondPhaseProducts);
              _this.excluded = _this.excluded.concat(secondPhaseProducts);
            });
          }
        });
      };

      function remainingProductsCount(carrousel){
        return carrousel.items.reduce((amount, item) => amount + item.max, 0);
      }

      function filterEmptyItemConfigs(items){
        let newItems = [];
        items.forEach(item => {
          if(item.max > 0){
            newItems.push(item);
          }
        });
        return newItems;
      }
    }

})();